/**
 * Which view of a project's Insights an address asks for, chosen by `?show=`.
 *
 * Apart from `project-insights.ts` (the control's markup) because the shell
 * reads it on every draw -- to know whether a lens, the manifold or the graph
 * canvas is wanted -- while only Insights itself draws the control.
 */

import { requestedView } from './nav.js';

export const INSIGHTS_SHOWS = ['graph', 'frontier', 'pressure', 'frontier-lens'] as const;

export type InsightsShow = (typeof INSIGHTS_SHOWS)[number];

/** `?show=` from the address; anything else is the semantic graph. */
export function requestedInsightsShow(search: string): InsightsShow {
  return requestedView(search, 'show', INSIGHTS_SHOWS, 'graph');
}
